import weather from "./img/weather.png";
import worldClock from "./img/world-clock.png";
import calculator from "./img/calculator.png";
import travel from "./img/travel.png";
import dictionary from "./img/dictionary.png";
import psychotherapy from "./img/psychotherapy.png";
import cineflix from "./img/cineflix.png";

export const projects = [
  {
    id: 1,
    title: "Weather App",
    languages: "HTML, CSS, JavaScript, and API",
    image: weather,
    link: "https://weather-app-andi.netlify.app",
  },
  {
    id: 2,
    title: "World Clock App",
    languages: "HTML, CSS, JavaScript, and API",
    image: worldClock,
    link: "https://world-clock-andihub.netlify.app",
  },
  {
    id: 3,
    title: "Calculator App",
    languages: "HTML, CSS, and JavaScript",
    image: calculator,
    link: "https://github.com/andreamorinigo7/mini-pocket-calculator",
  },
  {
    id: 4,
    title: "Travel Diary Landing Page",
    languages: "HTML and CSS",
    image: travel,
    link: "https://travel-project-andi.netlify.app/",
  },
  {
    id: 5,
    title: "Dictionary App",
    languages: "React",
    image: dictionary,
    link: "https://dictionary-andi.netlify.app",
  },
  {
    id: 6,
    title: "Psychotherapy Website",
    languages: "React",
    image: psychotherapy,
    link: "https://github.com/andreamorinigo7/silvia-balta-psychotherapist",
  },
  {
    id: 7,
    title: "Cinéflix",
    languages: "React and Jikan API",
    image: cineflix,
    link: "https://cineflix-anime.netlify.app",
  },
];
